/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-03-09 17:07:46
* @Last Modified by:   Bolt
* @Last Modified time: 2017-03-09 17:11:19
*/

'use strict';

import axios from 'axios';

function $showOtherShopCars(data) {
    return axios({
        url: '/json/showOtherShopCars.json',
        method: 'get',
        params: data
    });
}

function showOtherShopCars(data) {
    return $showOtherShopCars(data).then(response => response.data.item);
}

export default showOtherShopCars;



// WEBPACK FOOTER //
// ./src/api/json/showOtherShopCars.js